import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Pipe({
  name: 'accessibleLinks',
})
export class AccessibleLinksPipe implements PipeTransform {

  constructor(private translate: TranslateService) {}
  transform(html: string): string {
    const container = document.createElement('div');
    container.innerHTML = html;

    const links = container.querySelectorAll('a');

    links.forEach(link => {
      const target = link.getAttribute('target');

      if (target === '_blank') {
        // Add security attributes
        link.setAttribute('rel', 'noopener noreferrer');

        // Optional: Add a visually hidden suffix inside the link
        const srText = document.createElement('span');
        srText.className = 'sr-only';
        srText.textContent = ` ${this.translate.instant('SHARED.LINK.ACCESSIBILITY.NEW_WINDOW_TEXT')}`;
        link.appendChild(srText);
      }
    });

    return container.innerHTML;
  }
}

